import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      width={135}
      height={141}
      viewBox='0 0 135 141'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_118_1924)'>
        <path
          opacity={0.18}
          d='M74.173.068c-14.74 1.216-23.832 16.667-37.095 23.228-5.958 2.949-12.67 4.03-18.782 6.643C7.901 34.382-.87 44.664.068 55.941 1.285 70.559 17.03 79.636 21.98 93.44c1.365 3.81 1.865 7.889 3.273 11.681 3.513 9.464 13.034 16.369 23.106 16.761 8.09.314 15.809-3.168 23.813-4.395 9.8-1.507 19.789.399 29.708.061 9.919-.338 20.748-3.714 25.613-12.363 3.937-7.005 2.975-15.73.796-23.467-2.178-7.736-5.486-15.286-5.927-23.312-.509-9.347 2.52-20.114-3.643-27.15-4.574-5.233-13.022-6.468-16.285-12.606-3.522-6.61-4.758-7.49-10.68-11.41-5.857-3.883-9.858-7.809-17.58-7.172z'
          fill='#00D563'
        />
        <path
          d='M112.263 13.64H76.634a5.216 5.216 0 00-5.213 5.22v77.295a5.216 5.216 0 005.213 5.219h35.629a5.216 5.216 0 005.213-5.22V18.86a5.216 5.216 0 00-5.213-5.22z'
          fill='#00D563'
        />
        <path
          d='M115.582 20.222v73.77a4.88 4.88 0 01-4.873 4.877h-32.52a4.87 4.87 0 01-3.443-1.43 4.883 4.883 0 01-1.427-3.447V20.225c.001-1.294.514-2.534 1.428-3.45a4.872 4.872 0 013.444-1.43h4.95v.385a2.749 2.749 0 001.694 2.536c.332.138.689.21 1.049.21h16.877a2.73 2.73 0 001.939-.804 2.745 2.745 0 00.803-1.942v-.385h5.208a4.871 4.871 0 013.443 1.43 4.885 4.885 0 011.428 3.447z'
          fill='#00D563'
        />
        <path
          opacity={0.81}
          d='M115.582 20.222v73.77a4.88 4.88 0 01-4.873 4.877h-32.52a4.87 4.87 0 01-3.443-1.43 4.883 4.883 0 01-1.427-3.447V20.225c.001-1.294.514-2.534 1.428-3.45a4.872 4.872 0 013.444-1.43h4.95v.385a2.749 2.749 0 001.694 2.536c.332.138.689.21 1.049.21h16.877a2.73 2.73 0 001.939-.804 2.745 2.745 0 00.803-1.942v-.385h5.208a4.871 4.871 0 013.443 1.43 4.885 4.885 0 011.428 3.447z'
          fill='url(#paint0_linear_118_1924)'
        />
        <path
          opacity={0.17}
          d='M108.983 62.506H82.727a2.406 2.406 0 00-2.405 2.408v6.45a2.406 2.406 0 002.405 2.408h26.256a2.407 2.407 0 002.405-2.408v-6.45a2.407 2.407 0 00-2.405-2.408zM108.983 78.357H82.727a2.406 2.406 0 00-2.405 2.408v6.45a2.406 2.406 0 002.405 2.407h26.256a2.407 2.407 0 002.405-2.408v-6.45a2.407 2.407 0 00-2.405-2.407z'
          fill='#fff'
        />
        <path
          d='M123.582 68.92l-11.14-10.689s-4.055 3.215-2.325 9.035c1.731 5.819 7.359 12.823 7.359 12.823v16.054s.063 5.222-5.216 5.222H76.634s3.108 8.192 9.432 15.147c6.323 6.954 17.669 15.545 17.183 24.488h30.849s-7.903-28.167-5.187-39.626c2.716-11.459 1.702-25.713-5.329-32.453z'
          fill='url(#paint1_linear_118_1924)'
        />
        <path
          d='M76.427 46.953c-1.127-.276-3.952-2.226-6.253-4.31-1.462-1.322-2.714-2.699-3.188-3.737-1.22-2.673-1.436-8.525 3.188-8.077 0 0 1.886-.43 6.253 6.089 4.366 6.518 1.844 10.489 0 10.035z'
          fill='url(#paint2_linear_118_1924)'
        />
        <path
          d='M77.328 57.82c-1.18-.07-4.48-1.565-7.16-3.262-1.576-.997-2.948-2.064-3.57-2.956-1.684-2.408-2.945-8.126 1.685-8.515 0 0 .524-.237 1.886.472 1.14.588 2.863 1.822 5.36 4.389 5.472 5.625 3.699 9.986 1.799 9.872z'
          fill='url(#paint3_linear_118_1924)'
        />
        <path
          d='M74.456 71.961c-.783-.212-2.572-1.57-4.282-3.203-1.65-1.57-3.209-3.395-3.74-4.7-1.084-2.668-1.414-8.563 2.42-8.211 0 0 .408-.126 1.32.632.86.709 2.172 2.22 4.008 5.364 3.79 6.476 1.806 10.531.274 10.118z'
          fill='url(#paint4_linear_118_1924)'
        />
        <path
          d='M76.215 83.683c-.993-.076-3.879-1.53-6.04-3.084-1.02-.731-1.887-1.485-2.304-2.124-1.32-1.995-2.358-6.705 1.223-6.981 0 0 .304-.137 1.08.215.86.39 2.306 1.385 4.558 3.848 4.272 4.672 2.945 8.236 1.483 8.126z'
          fill='url(#paint5_linear_118_1924)'
        />
        <path
          opacity={0.17}
          d='M108.983 30.806H82.727a2.406 2.406 0 00-2.405 2.408v6.45a2.406 2.406 0 002.405 2.408h26.256a2.407 2.407 0 002.405-2.408v-6.45a2.407 2.407 0 00-2.405-2.408zM108.983 46.656H82.727a2.406 2.406 0 00-2.405 2.408v6.45a2.406 2.406 0 002.405 2.408h26.256a2.407 2.407 0 002.405-2.408v-6.45a2.407 2.407 0 00-2.405-2.408z'
          fill='#fff'
        />
        <path
          opacity={0.81}
          d='M70.174 30.83v11.803c-1.462-1.322-2.714-2.698-3.188-3.737-1.212-2.663-1.436-8.515 3.188-8.067z'
          fill='url(#paint6_linear_118_1924)'
        />
        <path
          opacity={0.81}
          d='M70.174 43.556v11.002c-1.575-.997-2.947-2.064-3.57-2.956-1.683-2.408-2.944-8.126 1.686-8.515 0 0 .524-.227 1.884.47z'
          fill='url(#paint7_linear_118_1924)'
        />
        <path
          opacity={0.81}
          d='M70.174 56.48v12.275c-1.65-1.57-3.209-3.394-3.74-4.7-1.084-2.668-1.414-8.563 2.42-8.21 0 .002.408-.13 1.32.634z'
          fill='url(#paint8_linear_118_1924)'
        />
        <path
          opacity={0.81}
          d='M70.174 71.709v8.89c-1.019-.731-1.886-1.485-2.303-2.124-1.32-1.995-2.358-6.705 1.223-6.981 0 0 .304-.137 1.08.215z'
          fill='url(#paint9_linear_118_1924)'
        />
        <path
          d='M66.647 8.971v91.44a5.222 5.222 0 01-1.525 3.689 5.196 5.196 0 01-3.683 1.528h-43.34a5.207 5.207 0 01-5.21-5.217V8.971a5.221 5.221 0 013.216-4.82 5.203 5.203 0 011.993-.397h43.34a5.202 5.202 0 014.813 3.22c.262.634.396 1.312.396 1.997z'
          fill='#00D563'
        />
        <path
          opacity={0.17}
          d='M26.183 3.754v101.874h-8.085a5.207 5.207 0 01-5.208-5.217V8.971a5.221 5.221 0 013.215-4.82 5.203 5.203 0 011.993-.397h8.085z'
          fill='#fff'
        />
        <path
          opacity={0.19}
          d='M58.534 51.845v16.483a2.648 2.648 0 01-2.643 2.646H12.89V49.201h43a2.639 2.639 0 012.644 2.644z'
          fill='url(#paint10_linear_118_1924)'
        />
        <path
          d='M53.03 45.233H3.193A2.645 2.645 0 00.55 47.879v16.483a2.645 2.645 0 002.643 2.647h49.839a2.645 2.645 0 002.643-2.647V47.88a2.645 2.645 0 00-2.643-2.646z'
          fill='#00D563'
        />
        <path
          opacity={0.19}
          d='M56.176 25.024h-34.31a1.256 1.256 0 01-.889-2.145c.236-.236.555-.369.889-.369h34.31a1.256 1.256 0 011.161 1.74 1.256 1.256 0 01-1.161.774z'
          fill='url(#paint11_linear_118_1924)'
        />
        <path
          opacity={0.19}
          d='M56.176 32.754h-34.31a1.256 1.256 0 01-.888-2.147c.236-.235.555-.368.888-.368h34.31a1.251 1.251 0 011.161.775 1.258 1.258 0 01-1.161 1.74z'
          fill='url(#paint12_linear_118_1924)'
        />
        <path
          opacity={0.19}
          d='M56.176 40.478h-34.31a1.256 1.256 0 01-.889-2.146c.236-.236.555-.368.889-.368h34.31a1.256 1.256 0 011.161 1.74 1.256 1.256 0 01-1.161.774z'
          fill='url(#paint13_linear_118_1924)'
        />
        <path
          opacity={0.19}
          d='M17.1 50.757v10.026a1.944 1.944 0 01-1.857 1.94.523.523 0 01-.085 0H5.145a1.942 1.942 0 01-1.943-1.945V50.757a1.945 1.945 0 011.943-1.943h10.013a1.938 1.938 0 011.943 1.943z'
          fill='url(#paint14_linear_118_1924)'
        />
        <path
          opacity={0.17}
          d='M15.464 61.2c0 .514-.074 1.023-.221 1.514a.523.523 0 01-.085 0H5.211a5.261 5.261 0 01.357-3.912 5.25 5.25 0 012.967-2.57 2.846 2.846 0 01-1.364-3.149 2.848 2.848 0 012.652-2.175 2.84 2.84 0 012.814 1.96 2.85 2.85 0 01-1.112 3.245 5.249 5.249 0 013.94 5.087z'
          fill='#fff'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_118_1924'
          x1={94.9495}
          y1={-44.9329}
          x2={94.1718}
          y2={112.888}
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset={0.97} stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id='paint1_linear_118_1924'
          x1={76.6345}
          y1={99.6154}
          x2={134.098}
          y2={99.6154}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_118_1924'
          x1={66.2366}
          y1={38.8961}
          x2={78.8436}
          y2={38.8961}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_118_1924'
          x1={65.0767}
          y1={50.4357}
          x2={79.1926}
          y2={50.4357}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_118_1924'
          x1={65.7109}
          y1={63.911}
          x2={76.3633}
          y2={63.911}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_118_1924'
          x1={66.6469}
          y1={77.5751}
          x2={77.6246}
          y2={77.5751}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#ECC4D7' />
          <stop offset={0.42} stopColor='#EFD4D1' />
          <stop offset={1} stopColor='#F2EAC9' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_118_1924'
          x1={57.2535}
          y1={37.2294}
          x2={68.4129}
          y2={36.7844}
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset={0.97} stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id='paint7_linear_118_1924'
          x1={57.7346}
          y1={49.2694}
          x2={68.8939}
          y2={48.8243}
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset={0.97} stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id='paint8_linear_118_1924'
          x1={58.2746}
          y1={62.7377}
          x2={69.4315}
          y2={62.2926}
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset={0.97} stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id='paint9_linear_118_1924'
          x1={58.8214}
          y1={76.4703}
          x2={69.9808}
          y2={76.0229}
          gradientUnits='userSpaceOnUse'
        >
          <stop />
          <stop offset={0.97} stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id='paint10_linear_118_1924'
          x1={32.0939}
          y1={54.855}
          x2={43.5792}
          y2={74.4745}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#183866' />
          <stop offset={1} stopColor='#1A7FC1' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_118_1924'
          x1={36.906}
          y1={14.2426}
          x2={39.4562}
          y2={25.7004}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#183866' />
          <stop offset={1} stopColor='#1A7FC1' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_118_1924'
          x1={35.2721}
          y1={14.6062}
          x2={37.8223}
          y2={26.064}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#183866' />
          <stop offset={1} stopColor='#1A7FC1' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_118_1924'
          x1={33.6381}
          y1={14.9696}
          x2={36.1884}
          y2={26.4275}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#183866' />
          <stop offset={1} stopColor='#1A7FC1' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_118_1924'
          x1={-12.6517}
          y1={55.7617}
          x2={-12.5692}
          y2={55.7617}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#183866' />
          <stop offset={1} stopColor='#1A7FC1' />
        </linearGradient>
        <clipPath id='clip0_118_1924'>
          <path fill='#fff' d='M0 0H134.098V141H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
